import BackOfficeCustomerService from '../../services/backofficeCustomer/BackofficeCustomerService';
import Identity from '../../components/modules/identity';
import TrackME from '../../components/modules/trackMe';

export function execute(username) {
  return new Promise((resolve, reject) => {
    BackOfficeCustomerService.getCustomer(username)
      .then(data => {
        TrackME.run(username, 'LOGIN');
        featureIdentity(username, 'LOGIN');
        resolve(data);
      })
      .catch(err => reject(err));
  });
}

function featureIdentity(sessionId, domain) {
  Identity.capturar(sessionId, domain);
}



// WEBPACK FOOTER //
// ./src/usecases/loginCallcenter/LoginCallcenterUC.js